import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackRegisterForAuctionPressedPayload = TrackingPayload & {
    isLoggedIn: boolean;
};

const trackRegisterForAuctionPressedAnalytics = (payload: TrackRegisterForAuctionPressedPayload) => {
    track(TrackingEvents.Registration.RegisterForAuctionPressed, payload);
};

export const useTrackRegisterForAuctionPressedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));
    const bidderId = useAppSelector(getBidderId);

    return useCallback(() => {
        trackRegisterForAuctionPressedAnalytics({
            isLoggedIn: bidderId > 0,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [bidderId, pathname, url]);
};
